import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  addSecondDropdownButton: {
    textAlign: 'left'
  }
})

export default useStyles
